import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, errorRedirect, inject, SubTopBar, Title } from 'Mri.Web.Common';
import { parse } from 'qs';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Input } from 'reactstrap';
import { PartsStore } from './PartsStore';
import { DisplayPartTreeItemCard } from './PartsTree';

export interface IPartsListParams {
    partGuid: string;
}
export interface IPartsListProps extends RouteComponentProps<IPartsListParams> {}

@autoinject
@observer
export class PartsTreeView extends React.Component<IPartsListProps> {
    @action
    public async componentDidMount() {
        try {
            await this.partsStore.loadPartsFromGuid(this.props.match.params.partGuid, true);
        } catch (e: any) {
            errorRedirect(e);
        }
    }

    public render() {
        return (
            <div className="container-fluid">
                <Title>{this.part?.description ?? 'Part'}</Title>

                <SubTopBar>
                    <Input
                        type="text"
                        value={this.searchValue}
                        onChange={this.onSearchInputChange}
                        className="mw-450"
                        placeholder="Search Parts..."
                    />
                </SubTopBar>

                <div className="row">
                    <div className="col-12 px-0 card">
                        <div className="row">
                            <div className="col-4" />
                        </div>
                    </div>
                    <div className="col-12 px-0">
                        {this.part && (
                            <div>
                                <DisplayPartTreeItemCard
                                    part={this.part}
                                    key={this.part.partGuid}
                                    searchValue={this.searchValue}
                                    partNavigation={this.partNavigation}
                                    showReplace={true}
                                    topLevelGuid={this.props.match.params.partGuid}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    @bind
    @action
    private onSearchInputChange(event: React.FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;
        this.searchValue = target.value;
    }

    @computed
    private get part() {
        return this.partsStore.parts.get(this.props.match.params.partGuid);
    }

    @computed
    private get partNavigation(): string | undefined {
        const query = parse(this.props.location.search.slice(1));

        if (typeof query.partNavigation == 'string') return query.partNavigation;
    }

    @observable
    private searchValue: string = '';
    @inject
    private partsStore!: PartsStore;
}
